import { FeaturesPage } from "./features/features.page";

export interface Key {

  index: number;
  black: boolean;
  state: string;
  transpose: number;
  note: string;
  label: string;
  number: number;
  row: number;
  col: number;
  octave: number;
  indian: boolean;
  pressed: boolean;
  button?: any;
  animation?: any;
  cache?: any;

}

export function defined(x) {
  if (typeof (x) != 'undefined')
    return true;
  return false;
}
export function notNull(x): boolean {
  if ((defined(x) && x != null))
    return true;
  return false;
}
export const consts = {
  LAST_SETTING: 'LAST_SETTING',
  MY_FUN_BOARD: 'MY_FUN_BOARD',
  MY_KEY_BOARDS: 'MY_KEY_BAORDS',
  TITLE_EXISTS: 'This title exists',
  ID_EXISTS: 'This id already exists',
  BUILT_IN: 'Built-In',
  GLOBAL_SETTINGS: 'Global'

}

export const MSG_TEXTS_LABELS = {
  FEATURE_IN_DEVELOPMENT: "The feature you attempted is either incomplete our absent. This will be delivered during the course of alpha and Beta test"
  , ATTENTION: "Attention"

}
type Bol = {
  name: string;
  synonyms?: string[];
  type?: string; // basic or combined
  url?: string; //relative url in  a lirbrary
  actualUri?: string;
  tunable?: boolean;
  buffer?: AudioBuffer;
  origBuffer?: AudioBuffer;
  baseFrequence?: number;
  duration?: number; // in beats.. can be fractions. Actual sound duration should be in Buffer.
  comboDuplex?: [string, string]; // consists of two primary bols
  surfaceName?: string; // must match surface names.
  comboTriplex?: [string, string, string]; //consists of three primary - like in a drum.
  joint2?: [string, string];// two bol in a sequence.. Tet. TeTe
  joint4?: [string, string, string, string] // four bol in a sequence (trak- TeReKeTe)
}
type RhythmSoundLibrary = {

  name: string;
  surfaces?: string[];
  surfaceCount?: number;


  rootUri?: string;
  basicSounds: Bol[];

}
interface StringObjMap {
  [index: string]: any;
}
const DevicesOption = [
  5,
  7,
  10,
  '5s',
  'desktop'
];

const DevicesDescr = {
  5: 'Mobile phone 5 inch broad',
  7: "7 inch tablet",
  10: "10 inch tablet",
  '5s': "Small mobile phone -narrow",
  'desktop': "Desktop or chromebook"
};

interface Board {
  id: string;
  title: string;
  rows: number;
  cols: number;
  assignments: any[];
  deviceSkins: string[];
  instrSkin: string;
  utype?: boolean;
kboardIndex?:number,
}

export interface BoardGeometry {
  zoom?: number,
  offset?: number,
  yoffset?: number
  mobile: false

}
export interface BoardControl {


  bend: boolean,
  expand: boolean,
  tremolo?: boolean,
  vibrator?: boolean,
  swipe?:boolean,
  expanded?: boolean,
  lastCmd?: string,
  toggletanpura?: () => void,
  taanpuraOn?: () => boolean,
  toggleRecording?: () => void,
  recodingOn?: () => boolean,
  showVolume?: ()=>void,
  showConsole?:()=> void,
  showTranspose?:()=> void,
  showSettings?:()=> void,
  setInstrument?:(n: string)=>void,
  instrStatus?: (n: string) => boolean,
  leftSvgPressed?: () => void,
  rightSvgPressed?: () => void,
  getSkuStatus?: (sku: string) => boolean,
  dismiss?:()=>void,
  icons?:string[],
  currentTrack:any
}

export interface BoardWidget {

  trackChanged(option?: any): void;
  controlChanged(option?: any): void;
  scaleChanged(option?: any): void;
  tempoChanged(option?: any): void;
  geometryChanged(option?: any): void;

}

export class Song {
  title = "untitled";
  genres = [];
  columnsLandScape = 8;
  landscape = [];
  portrait = [];
  instruments = [];
  taal = "";
  style = ""
  tempo = 60;
  ragaa: "";
  wiki: "";
  thaat: "";
  album: "";
  vendor: "";
  instListRec?: any;
  kboardIndex=48;
}



export function downloadJSON(content, fileName, contentType) {
  const a = document.createElement("a");
  const file = new Blob([content], { type: contentType });
  a.href = URL.createObjectURL(file);
  a.download = fileName;
  a.click();
}

export enum UnlockTypes {
  UNLOCK_BRONZE_DAILY = 1,
  UNLOCK_SILVER_DAILY = 2,
  UNLOCK_GOLD_DAILY = 3,
}
export {
  Board, Bol, RhythmSoundLibrary, StringObjMap, DevicesOption, DevicesDescr
};


export enum Features {
  SYNTH = 'synth',
  TESTFAIL = 'testfail',
  RECORD = 'record',
  TAANPURA = 'taanpura',
  TABLA = 'tabla',
  UBOARD = 'uboard',
  DBL_PIANO = 'doublePiano',
  ROLI_BOARD = 'roli_board',
  THAAT_LAYOUT = 'thaat_layout',
  RAAGA_LAYOUT = 'raaga_layout',
  SONG_LAYOUT = 'song_layout',
  RAAGA_INFO = 'raaga-info'

}

interface Operation 
{
  selectInstCallback:(str:string)=> void;
  currentInstCallback:()=>string;
  

}

export interface Effect 
{
  effects:string[];
  compressor?:any;
  reverb?:any;
  equalizer?:any;
  balancer?:any;
  panner?:any;
}
